import React from 'react'
import {createContext, ReactNode, useContext, useState} from "react";
import { genericFilterType } from '../stateManagement/reducers/genericFilterReducer';

interface reportGlobalFiltersContextType {
    reportGlobalFiltersState:genericFilterType,
    setReportGlobalFiltersState:React.Dispatch<React.SetStateAction<genericFilterType>>
}

const ReportGlobalFiltersContext = createContext<reportGlobalFiltersContextType>({} as reportGlobalFiltersContextType);

const ReportGlobalFiltersProvider = ({children}: { children: ReactNode }) => {
    const [reportGlobalFiltersState, setReportGlobalFiltersState] = useState<genericFilterType>({})
  return (
    <ReportGlobalFiltersContext.Provider value={{reportGlobalFiltersState, setReportGlobalFiltersState}}>
        {children}
    </ReportGlobalFiltersContext.Provider>
  )
}

export function useReportGlobalFilters(): reportGlobalFiltersContextType {
    return useContext(ReportGlobalFiltersContext);
}

export default ReportGlobalFiltersProvider;

